import { useEffect, useState } from 'react';
import { RestrospectiveFormState } from 'routes/HumanResourcesModule/Retrospective/RetrospectiveHome/RetrospectiveModal/RetrospectiveForm';

export function useRetrospectiveFormState(
    initialState: RestrospectiveFormState,
    editMode: boolean,
): [
    RestrospectiveFormState,
    React.Dispatch<React.SetStateAction<RestrospectiveFormState>>,
] {
    const [state, setState] = useState(initialState);
    const [isFormValid, setIsFormValid] = useState(false);
    const currentYear = new Date().getFullYear();

    useEffect(() => {
        if (
            state.title &&
            state.exercice <= currentYear &&
            state.exercice >= currentYear - 2
        )
            setIsFormValid(
                editMode || state.selectedOrgChartHrsSoftwareIds.length > 0,
            );
    }, [state.title, state.selectedOrgChartHrsSoftwareIds]);

    return [{ ...state, isFormValid }, setState];
}
